import { Injectable, inject } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { PlatformService } from './platform.service';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly platform = inject(PlatformService);

  async get(key: string): Promise<string | null> {
    if (this.platform.isNativeMobile()) {
      const { value } = await Preferences.get({ key });
      return value;
    }
    return localStorage.getItem(key);
  }

  async set(key: string, value: string): Promise<void> {
    if (this.platform.isNativeMobile()) {
      await Preferences.set({ key, value });
    } else {
      localStorage.setItem(key, value);
    }
  }

  async remove(key: string): Promise<void> {
    if (this.platform.isNativeMobile()) {
      await Preferences.remove({ key });
    } else {
      localStorage.removeItem(key);
    }
  }

  async clear(): Promise<void> {
    if (this.platform.isNativeMobile()) {
      await Preferences.clear();
    } else {
      localStorage.clear();
    }
  }

  async keys(): Promise<string[]> {
    if (this.platform.isNativeMobile()) {
      const { keys } = await Preferences.keys();
      return keys;
    }
    return Object.keys(localStorage);
  }

  getSync(key: string): string | null {
    return localStorage.getItem(key);
  }

  setSync(key: string, value: string): void {
    localStorage.setItem(key, value);
    if (this.platform.isNativeMobile()) {
      // eslint-disable-next-line no-console
      Preferences.set({ key, value }).catch(console.error);
    }
  }

  removeSync(key: string): void {
    localStorage.removeItem(key);
    if (this.platform.isNativeMobile()) {
      // eslint-disable-next-line no-console
      Preferences.remove({ key }).catch(console.error);
    }
  }
}
